import Lesson from './Lesson.route';

export default Lesson;
